import * as types from '../../actions/actiontypes';
import Utility from '../../util/utilityfunctions';
import initialState from '../initialstate';
import {cloneDeep} from 'lodash';

export function commonClientRequestCustomFiltersReducer(state = initialState.commonClientReqCustomFilter, action) {
	switch (action.type) {
		case types.SET_COMMON_CLIENT_REQUESTS_FILTER: {
			let clonedState = cloneDeep(state);
			clonedState = {
				...clonedState,
				isBulk: false
			};
			let value = action.value;
			if (!Utility.hasValue(value)) {
				// If filter is being disabled, set to empty array so it's removed from the URL.
				value = [];
			}
			let filters;
			filters = {...clonedState};

			if (action.filterKey && action.filterItemName) {
				if (!filters[action.filterKey]) {
					filters[action.filterKey] = {};
				}
				if (value.length < 1) {
					const {[action.filterItemName]: removedProperty, ...stateRest} = filters[action.filterKey];
					return {...clonedState, [action.filterKey]: stateRest};
				}
				filters[action.filterKey][action.filterItemName] = value;
				filters.isLoaded = true;

				return {
					...clonedState,
					...filters
				};
			}
			return clonedState;
		}

		case types.CLEAR_COMMON_CLIENT_REQUESTS_FILTERS: {
			let filterData = cloneDeep(state);

			if (action.filterKey) {
				filterData[action.filterKey] = {};
			}
			return filterData;
		}

		case types.SET_BULK_COMMON_CLIENT_REQUESTS_FILTERS: {
			const customFilters = action.bulkData.reduce((result, filter) => {
				result[filter.filterItemName] = filter.value;
				return result;
			}, {});

			return {...state, [action.filterKey]: customFilters, isBulk: action.isBulk, isLoaded: true};
		}

		default:
			return state;
	}
}
